import { Invoice } from '@alliance-disposal/transport-types';
const BASE_LINE_ITEM_NAMES = new Set([...Invoice.DefaultLineItems, 'Haul', 'Dump']);
// An overage is a post-service charge: it can be billed on a draft of its own, so it does not mark the
// quoted invoice, and on the booking draft it counts only in totalPrice.
const QUOTED_LINE_ITEM_NAMES = new Set([...BASE_LINE_ITEM_NAMES].filter((name) => name !== 'Overage'));
// Mirrors apps/wayste/src/components/OrderDetails/OrderDetailsBillingCard/OrderDetailsBillingCard.tsx:
// "quoted" = the receivable containing QP-Haul; "total" = sum of every receivable on the sub.
export const deriveBillingFromReceivables = (receivables) => {
    if (receivables.length === 0)
        return null;
    const quoted = receivables.find((r) => (r.invoiceDetails.lineItems ?? []).some((li) => QUOTED_LINE_ITEM_NAMES.has(li.itemName)));
    let quotedPrice = 0;
    const feeNames = [];
    const discountNames = [];
    for (const li of quoted?.invoiceDetails.lineItems ?? []) {
        const total = li.totalPrice ?? 0;
        if (BASE_LINE_ITEM_NAMES.has(li.itemName)) {
            if (QUOTED_LINE_ITEM_NAMES.has(li.itemName))
                quotedPrice += total;
        }
        else if (total < 0) {
            if (li.itemName)
                discountNames.push(li.itemName);
        }
        else if (total > 0) {
            if (li.itemName)
                feeNames.push(li.itemName);
        }
    }
    const totalPrice = receivables.reduce((acc, r) => acc + (r.invoiceDetails.total ?? 0), 0);
    return {
        quotedPrice,
        totalPrice,
        taxRate: quoted?.invoiceDetails.taxRate ?? 0,
        feeNames,
        discountNames,
    };
};
//# sourceMappingURL=derive-billing-from-receivables.js.map